// Module
var code = "<div class=\"form-control\" ng-jsoneditor ng-model=\"data[component.key][index].name\" options=\"component.options\" prefer-text=\"component.preferText\" ng-attr-name=\"{{ componentId }}-{{ index }}\" ng-change=\"changeValue()\"></div> ";
// Exports
export default code;